import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { HomeApi } from 'api';

function useGet() {
  return useAuthQuery(getQueryKeys(KEY).details(), () => HomeApi.get(), {});
}

export default useGet;
